import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "mt-2" };
const _hoisted_5 = { class: "div-textarea wh-pl" };
import { computed, onMounted, onUnmounted, ref, } from 'vue';
import { routeName } from '@/constants/routeName';
import { useRoute, useRouter, } from 'vue-router';
import CardSection from '@/components/Common/CardSection.vue';
import BoardFooter from '@/components/Common/BoardFooter.vue';
import { storeToRefs } from 'pinia';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { i18n } from '@/locales';
import { alertActionType } from '@/vuex-store/alert/actions';
import InputRow from '@/components/Form/InputRow.vue';
import { objDeepCompare } from '@/utils/object';
import { autoLcStoreWorkProcess } from '@/locales/ko/views/store_work_process';
import { createStoreWorkProcessFormRule } from '@/form/form-rules/storeWorkProcess';
import { pStore } from '@/pinia';
import { getFormValueForPinia, setFormValueForPinia, } from '@/utils/form';
import SubController from './SubController.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // PAGE: 상점 업무처리 신규 등록, 답변 등록, 수정, 답변 수정
        const lc = autoLcStoreWorkProcess();
        const formRule = createStoreWorkProcessFormRule();
        const route = useRoute();
        const router = useRouter();
        const pStoreWorkProcess = pStore.piniaStoreWorkProcess;
        const { storeList, formData, originFormData, itemDetail, } = storeToRefs(pStoreWorkProcess);
        const pageId = route.params.itemId;
        const isEditPage = route.name === routeName.STORE_WORK_PROCESS_EDIT;
        const isCreatePage = route.name === routeName.STORE_WORK_PROCESS_CREATE;
        const isCreateReplyPage = route.name === routeName.STORE_WORK_PROCESS_CREATE_REPLY;
        const isEditReplyPage = route.name === routeName.STORE_WORK_PROCESS_EDIT_REPLY;
        const isPossibleSelectHub = computed(() => isCreatePage && vuexStore.getters['user/isHead']);
        const formRef = ref(null);
        const confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        const submitButtonText = computed(() => '완료');
        /**
         * 스위치 변경 핸들러
         */
        const handleChangeSwitch = (value) => {
            formData.value.isImportant = value;
        };
        /**
         * 객체 채크
         * @param routeData
         */
        const checkFormData = async (routeData) => {
            const isSameData = objDeepCompare(originFormData.value, formData.value);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            if (isSameData) {
                router.push(routeData).catch(() => { });
                return;
            }
            const isConfirmOk = await confirm({
                headerTitle: i18n.t('common.cancel'),
                bodyContent: i18n.t('common.confirm_before_cancel'),
            });
            if (isConfirmOk) {
                router.push(routeData).catch(() => { });
            }
        };
        /**
         * 목록 클릭 핸들러
         */
        const handleClickReturnBtn = async () => {
            // 수정페이지면 상세보기, 등록페이지면 목록 페이지로 간다.
            const name = routeName.STORE_WORK_PROCESS;
            checkFormData({
                name,
                query: route.query,
            });
        };
        /**
         * 취소 클릭 핸들러
         */
        const handleClickCancelBtn = async () => {
            // 수정페이지면 상세보기, 등록페이지면 목록 페이지로 간다.
            const name = pageId
                ? routeName.STORE_WORK_PROCESS_DETAIL
                : routeName.STORE_WORK_PROCESS;
            const params = pageId ? {
                workerNoticeId: pageId,
            } : {};
            checkFormData({
                name,
                query: route.query,
                params,
            });
        };
        /**
         * 허브 리스트
         */
        const hubList = computed(() => vuexStore.state.hubSelector.hubs);
        /** 대상 선택 */
        const storeTargetType = ref([
            {
                key: 1,
                label: '소속 상점 전체',
                value: 'ALL',
            },
            {
                key: 2,
                label: '상점 선택',
                value: 'BY_STORE',
            },
        ]);
        /**
         * 전송
         */
        const handleSubmitForm = async () => {
            const { valid } = await formRef.value.validate();
            let func = () => { };
            if (!valid) {
                return;
            }
            switch (true) {
                case isCreatePage:
                    func = pStoreWorkProcess.createNotice;
                    break;
                case isEditPage:
                    func = pStoreWorkProcess.updateNotice;
                    break;
                case isCreateReplyPage:
                    func = pStoreWorkProcess.createReply;
                    break;
                default: break;
            }
            // api 호출
            try {
                const result = await func();
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                router.push({
                    name: routeName.STORE_WORK_PROCESS_DETAIL,
                    params: {
                        itemId: result?.data?.id || pageId,
                    },
                    query: route.query,
                }).catch(() => { });
            }
            catch (error) {
                console.log(error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        };
        /**
         * 삭제된 글이면 리턴 시킨다.
         */
        const checkIsDeleted = () => {
            if (itemDetail.value.isDeleted) {
                vuexStore.dispatch(snackbarActionType.showError);
                router.push({
                    name: routeName.STORE_WORK_PROCESS,
                });
            }
        };
        /**
         * 초기화
         */
        const initItem = async (_id) => {
            try {
                const response = await pStoreWorkProcess.getItem(_id);
                checkIsDeleted();
                if (isCreateReplyPage) {
                    pStoreWorkProcess.setFormDataForCreateReplyPage(response);
                }
                else {
                    pStoreWorkProcess.setFormData(response);
                }
            }
            catch (error) {
                console.log('storeWorkProcess/initItem', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        };
        /**
         * 허브 선택 이벤트 핸들러
         */
        const handleUpdateSelectedHub = async () => {
            if (formData.value.selectedHubId === 'ALL') {
                formData.value.targetType = 'ALL';
                formData.value.selectedStoreList = [];
                return;
            }
            try {
                await pStoreWorkProcess.getStoreList();
            }
            catch (error) {
                console.log('storeWorkProcess/handleUpdateSelectedHub', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
            formData.value.selectedStoreList = [];
        };
        const hubName = computed(() => vuexStore.getters['user/hubName']);
        /**
         * 부족한 데이터 폼 초기화
         */
        const initForm = () => {
            const injectFormData = {
                createdByName: vuexStore.state.user.userInfo.name,
                selectedHubId: vuexStore.getters['user/hubId'],
                isHead: vuexStore.getters['user/isHead'],
            };
            [
                formData.value,
                originFormData.value,
            ].forEach((form) => {
                Object.assign(form, injectFormData);
            });
        };
        const getFormValue = (key) => getFormValueForPinia(formData, key);
        const setFormValue = (key, value) => setFormValueForPinia(formData, key, value);
        /**
         * 페이지 초기화
         */
        onMounted(async () => {
            if (pageId) {
                await initItem(pageId);
            }
            initForm();
            await pStoreWorkProcess.getStoreList();
        });
        onUnmounted(() => {
            pStoreWorkProcess.$reset();
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_switch = _resolveComponent("v-switch");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_form, {
                    class: "cy-form",
                    ref_key: "formRef",
                    ref: formRef,
                    onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createVNode(SubController),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(CardSection, null, {
                                titleContent: _withCtx(() => [
                                    _createCommentVNode(" 제목 "),
                                    _createVNode(InputRow, {
                                        "input-row-class": "",
                                        label: _unref(i18n).t('common.text_title')
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                class: "cy-title",
                                                density: "comfortable",
                                                variant: "outlined",
                                                "hide-details": "auto",
                                                "validate-on": "blur",
                                                rules: _unref(formRule).title,
                                                placeholder: _unref(lc)('placeholder.title'),
                                                "model-value": getFormValue('title'),
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => setFormValue('title', value))
                                            }, null, 8 /* PROPS */, ["rules", "placeholder", "model-value"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label"])
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(InputRow, {
                                        class: "brg-input-section-dense-wrapper",
                                        label: _unref(lc)('form.author')
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(getFormValue('createdByName')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label"]),
                                    isCreatePage
                                        ? (_openBlock(), _createBlock(InputRow, {
                                            key: 0,
                                            class: _normalizeClass(isEditPage ? 'brg-input-section-dense-wrapper' : ''),
                                            label: _unref(lc)('form.target')
                                        }, {
                                            default: _withCtx(() => [
                                                _createCommentVNode(" 허브 선택 "),
                                                (isPossibleSelectHub.value)
                                                    ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                                                        key: 0,
                                                        "item-title": "text",
                                                        "item-value": "key",
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": "auto",
                                                        class: "cy-autocomplete",
                                                        modelValue: _unref(formData).selectedHubId,
                                                        "onUpdate:modelValue": [
                                                            _cache[1] || (_cache[1] = ($event) => ((_unref(formData).selectedHubId) = $event)),
                                                            handleUpdateSelectedHub
                                                        ],
                                                        disabled: isEditPage,
                                                        items: hubList.value,
                                                        placeholder: _unref(lc)('placeholder.select_store')
                                                    }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder"]))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(hubName.value), 1 /* TEXT */)),
                                                _createCommentVNode(" 상점 전체 여부 "),
                                                _createElementVNode("div", _hoisted_4, [
                                                    _createVNode(_component_v_radio_group, {
                                                        inline: "",
                                                        "hide-details": "",
                                                        class: "cy-target-type-radio",
                                                        name: "storeTargetRadio",
                                                        density: "compact",
                                                        "model-value": getFormValue('targetType'),
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => setFormValue('targetType', value))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeTargetType.value, (option) => {
                                                                return (_openBlock(), _createBlock(_component_v_radio, {
                                                                    key: option.key,
                                                                    label: option.label,
                                                                    value: option.value,
                                                                    disabled: _unref(formData).selectedHubId === ''
                                                                }, null, 8 /* PROPS */, ["label", "value", "disabled"]));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["model-value"])
                                                ]),
                                                _createCommentVNode(" 상점 선택 "),
                                                (_unref(formData).targetType !== 'ALL')
                                                    ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                                                        key: 2,
                                                        chips: "",
                                                        "closable-chips": "",
                                                        multiple: "",
                                                        class: "mt-2 cy-store-autocomplete",
                                                        "item-title": "name",
                                                        "item-value": "code",
                                                        modelValue: _unref(formData).selectedStoreList,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(formData).selectedStoreList) = $event)),
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": "auto",
                                                        items: _unref(storeList),
                                                        placeholder: _unref(lc)('placeholder.select_store'),
                                                        rules: _unref(formRule).storeList
                                                    }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder", "rules"]))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["class", "label"]))
                                        : _createCommentVNode("v-if", true),
                                    (isCreateReplyPage || isEditReplyPage)
                                        ? (_openBlock(), _createBlock(InputRow, {
                                            key: 1,
                                            label: _unref(lc)('form.origin_body')
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formData).parentBody.replace(/<br>/g, "\r\n")), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"]))
                                        : _createCommentVNode("v-if", true),
                                    _createVNode(InputRow, {
                                        label: _unref(lc)('form.body')
                                    }, {
                                        default: _withCtx(() => [
                                            _createCommentVNode(" 본문 "),
                                            _createVNode(_component_v_textarea, {
                                                class: "cy-body",
                                                variant: "outlined",
                                                rows: "10",
                                                "row-height": "20",
                                                "hide-details": "auto",
                                                placeholder: _unref(lc)('placeholder.body'),
                                                "validate-on": "blur",
                                                rules: _unref(formRule).body,
                                                "model-value": getFormValue('body'),
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => setFormValue('body', value))
                                            }, null, 8 /* PROPS */, ["placeholder", "rules", "model-value"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label"]),
                                    _createVNode(InputRow, {
                                        label: _unref(lc)('is_important')
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_switch, {
                                                class: "cy-switch",
                                                color: "primary",
                                                "model-value": _unref(formData).isImportant,
                                                "onUpdate:modelValue": handleChangeSwitch,
                                                density: "compact",
                                                label: _unref(formData).isImportant ? _unref(lc)('is_important_on') : _unref(lc)('is_important_off'),
                                                "hide-details": ""
                                            }, null, 8 /* PROPS */, ["model-value", "label"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label"])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createCommentVNode(" footer "),
                        _createVNode(BoardFooter, null, {
                            left: _withCtx(() => [
                                _createCommentVNode(" 목록 "),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                _createTextVNode(" mdi-chevron-left ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [5]
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_unref(i18n).t('common.back_to_list')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ])
                            ]),
                            right: _withCtx(() => [
                                _createCommentVNode(" 취소 "),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickCancelBtn }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(i18n).t('common.cancel')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ]),
                                _createCommentVNode(" 완료 "),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    type: "submit",
                                    class: "cy-submit-btn"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { small: "" }, {
                                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                _createTextVNode(" mdi-check ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [6]
                                        }),
                                        _createTextVNode(" " + _toDisplayString(submitButtonText.value), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            primary: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
            ]));
        };
    }
});
